<script>
    import { store, totalPayment } from '../../Store.svelte';
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import DangerPannel from '../../components/DangerPannel.svelte';
    const isSky = $store.requestedServices.isSky;
    let shouldShowInstalationDate = !$store.requestedServices.isSpMovil;
    import { env } from '../../Environment.svelte';

    export let payList = env[env.stage].urlIzziWebPayList;

    onMount(() => {
        document.querySelector('header').classList.add('header--ticket');
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
        $store.settings.location = { progress: 100, step: 7 };
    });

    let purchaseStatus = $store.purchaseStatus;
    if (!purchaseStatus.finalized) {
        if (purchaseStatus.accountNumber != null) {
            if (
                purchaseStatus.installationDate != null &&
                purchaseStatus.installationDate.length > 0
            ) {
                navigate('/compra/pago', { replace: false });
            } else {
                navigate('/compra/fecha', { replace: false });
            }
        } else if (
            $store.requestedServices.productId != null &&
            $store.requestedServices.productId.length > 0
        ) {
            navigate('/compra/configura', { replace: false });
        } else {
            navigate('/compra/comparador', { replace: false });
        }
    }

    function finishStep() {
        navigate('/comparador', { replace: false });
    }
</script>

<div class="pure-g justify-content-center">
    <div class="welcome">
        <h1 class="text-fs-23 fw-semibold m-b-15">
            ¡Te damos la bienvenida! {$store.personalDetails.nombre}
        </h1>
        {#if isSky}
            <div class="divider-sky"></div>
        {/if}
        <div
            class="accordion-holder {isSky
                ? 'ticket--holder--sky'
                : 'ticket--holder'} m-b-40"
        >
            <div class="accordion-panel">
                {#if $store.purchaseStatus.error != null}
                    <div class="alert alert--error m-b-40">
                        <p>
                            Ocurrió un error en los últimos pasos de tu
                            contratación, un asesor se comunicará contigo para
                            completar la venta.
                        </p>
                        <p class="m-t-10 technical_error">
                            Error técnico: {$store.purchaseStatus.error}
                        </p>
                    </div>
                {/if}
                {#if $store.requestedServices.flagAutoinstalacion}
                    <DangerPannel />
                {/if}
                <div
                    class="alert alert--success alert--with-icon {$store.purchaseStatus.paymentType.indexOf(
                        'ONLINE'
                    ) >= 0
                        ? ''
                        : 'hidden'}"
                >
                    <svg class="icon" aria-hidden="true"
                        ><use
                            xlink:href="/assets/img/icons/symbol-defs.svg#icon-check-circle"
                        /></svg
                    >
                    <p>Tu pago fue realizado con éxito.</p>
                </div>
                <div
                    class="alert {$store.purchaseStatus.paymentType.indexOf(
                        'IZZI_CHANNELS'
                    ) >= 0
                        ? ''
                        : 'hidden'}"
                >
                    <p class="fw-semibold m-b-10">Pago pendiente</p>
                    <p class="m-b-10">
                        Presenta el codigo de barras para realizar tu pago.
                        Recuerda que tienes 36 horas para confirmarlo. Realiza
                        el pago en los siguientes establecimientos:
                    </p>
                    <div class="payment-stores">
                        {#if isSky}
                            <img
                                class="sky-logo"
                                src="/assets/img/logos/sky-logo.svg"
                                alt="Tiendas sky"
                            />
                        {:else}
                            <img
                                class="izzi-logo"
                                src="/assets/img/logos/izzi-logo.svg"
                                alt="Tiendas izzi"
                            />
                        {/if}
                        <img
                            class="oxxo-logo"
                            src="/assets/img/dummy-img/logos/oxxo-logo@2x.png"
                            alt="Oxxo"
                        />
                        <img
                            class="seven-logo"
                            src="/assets/img/dummy-img/logos/seven-eleven-logo@2x.png"
                            alt="Seven Eleven"
                        />
                        <img
                            class="aurrera-logo"
                            src="/assets/img/dummy-img/logos/bodega-aurrera@2x.png"
                            alt="Bodega Aurrera"
                        />
                    </div>
                    <a
                        href={payList}
                        class="base-text underline fw-semibold"
                        target="_blank"
                        ><strong>Consulta la lista completa aqui</strong></a
                    >
                </div>
                <div
                    class="alert {$store.purchaseStatus.paymentType.indexOf(
                        'VENDOR'
                    ) >= 0
                        ? ''
                        : 'hidden'}"
                >
                    <p class="fw-semibold m-b-10">Pago pendiente</p>
                    <p class="m-b-0">
                        Tu pago será requerido por el técnico el día de la
                        instalación
                    </p>
                </div>
                {#if shouldShowInstalationDate}
                    <div class="panel panel--lightgray panel--slim m-b-15">
                        <div class="d-flex align-items-center">
                            <svg class="icon" aria-hidden="true"
                                ><use
                                    xlink:href="/assets/img/icons/symbol-defs.svg#icon-calendar"
                                /></svg
                            >
                            <div class="m-l-15">
                                <p class="fw-semibold m-b-0">
                                    Fecha de instalación
                                </p>
                                <p class="m-b-0">
                                    {$store.purchaseStatus.installationDate}
                                </p>
                            </div>
                        </div>
                    </div>
                {/if}
                <div class="pure-g">
                    <div class="pure-u-1 pure-u-md-1-3">
                        <p class="fw-semibold m-b-0">Número de cuenta</p>
                        <p>{$store.purchaseStatus.accountNumber}</p>
                    </div>
                    <div class="pure-u-1 pure-u-md-1-3">
                        <p class="fw-semibold m-b-0">Número telefónico</p>
                        <p>{$store.personalDetails.numeroCelular}</p>
                    </div>
                    <div class="pure-u-1 pure-u-md-1-3 m-b-30">
                        <input
                            type="hidden"
                            name="barcode-val"
                            id="barcode-val"
                            value={$store.purchaseStatus.accountNumber10D}
                        />
                        <canvas id="barcode" class="barcode-canvas"></canvas>
                    </div>
                </div>
                <!--p class="m-b-15">Tu cuenta se creo con éxito, revisa tu correo para activar tu cuenta. Si no recibiste el correo de activación, <a href="#/" class="primary-text underline">haz clic aquí</a></p-->
                <p class="m-b-0">
                    Te hemos enviado una copia de tu recibo al correo <span
                        class="fw-semibold"
                        >{$store.personalDetails.correo}</span
                    >, conserva este recibo para cualquier aclaración.
                </p>
            </div>
            <div class="accordion-panel">
                <div class="pure-g">
                    <div class="pure-u-7-12">
                        <div
                            class="h2 text-fs-23 fw-semibold {isSky
                                ? 'blue-dark-text'
                                : 'primary-text'}"
                        >
                            Total
                        </div>
                    </div>
                    <div class="pure-u-5-12 text-right">
                        <div
                            class="h2 text-fs-23 fw-semibold {isSky
                                ? 'blue-dark-text'
                                : 'primary-text'}"
                        >
                            ${$totalPayment}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <p class="text-fs-15 m-b-20">
                Descarga izzi app y complementa tu servicio con beneficios
                adicionales como: Revisar tu estado de cuenta, pagar tus
                servicios, controlar tu wifi, modificar tus servicios ¡y mucho
                más!
            </p>
            <div class="download-container">
                <a
                    href="https://play.google.com/store/apps/details?id=telecom.televisa.com.izzi&hl=en"
                >
                    <img
                        class="download-images"
                        src="/assets/img/logos/play-store.svg"
                        alt="Google Play"
                    />
                </a>
                <a href="https://apps.apple.com/mx/app/izzi/id1001336742">
                    <img
                        class="download-images ios"
                        src="/assets/img/logos/app-store.svg"
                        alt="App Store"
                    />
                </a>
            </div>
        </div>
    </div>
</div>

<style>
    .technical_error {
        opacity: 0.3;
    }
</style>
